import './landDetails.css';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Collapse, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Fab, CardContent, RadioGroup, Radio, FormGroup, FormLabel, FormControlLabel, Switch, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import moment from 'moment';

import { GET_GROWER_BAMBOO_SPECIES, UPLOAD_DCUMENT, authKey, ResourceUpdateMember } from '../../../../../common/URLs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import "react-datepicker/dist/react-datepicker.css";
import { BambooSpeciesPopover } from '../../../../../preregcamps/confirmPopover/bambooSpeciesPopover';
import { ROLES, BASIC_DATE_FORMAT, API_DATE_FORMAT, BLOCK_LIST, SOURCING, EMPTY_FIELD_ERROR, LAND_AREA_UNIT, PINCODE_NO_ERROR, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, UPLOAD_FILE_TEXT, LAND_AREA_ERROR } from '../../../../../common/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogContent, IconButton, Dialog } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { VALIDATION, addressMaxLength, landAreaValidation, openTextFieldMaxLength, pincodeValidation, typeNumberValid } from '../../../../../common/commonValidations';
import { loaderService } from '../../../../../common/custom-loader/loader-service';
import { CommonPincodeMUI } from '../../../../../common/common-pincode/commonPincodeMUI';
import jwt from 'jwt-decode';
import { FileUploadMUI } from "../../../../../common/fileUpload/fileUploadMUI";
import { getLocalStorageItem } from '../../../../../common/localStorageUtils';
import { PROD } from '../../../../../common/constants';
import BackButton from '../../../../../common/backButton';
import { LocationPointMUI } from '../../../../../common/locationPoints/locationPointMUI';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../../../common/customDataGridToolbar';
import { Add as AddIcon, KeyboardArrowLeftRounded, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { insertComment } from '../../commonRegistrationStakeholderAPIs';
import { v4 as uuidv4 } from 'uuid';
import { useGrowerIndividulalContextData } from '../../registrationDetails';
import Badge from 'react-bootstrap/Badge';
import { handleNumberFieldFocus } from '../../../../../common/commonFunction';
import { Tooltip, } from '@mui/material';
import { CloseIcon, SaveIcon, UpdateIcon } from '../../../../../common/icons';
import apiClient from '../../../../../axios';
import BadgeComponent from '../../../../../common/badge';
import CommentIcon from '@mui/icons-material/Comment';

const LandDetails = ({ urn, bambooSpeciesRes }) => {
    const { stakeHolderDetails, growerDetails, landDetailsSectionOk, setLandDetailsSectionOk, shouldActOnSectionLand, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, showCommentSection, setCommentsData, comments, setComments, enableFieldFunction, currentPage, buttonAction, setButtonAction, landUpdatedDetails, setLandUpdatedDetails, errorMessage, setErrorMessage, expandedSection, setExpandedSection, regScruResourceUpdate, setRegScruResourceUpdate, setNewLandComments, setCallUpdateApi, newLandArray, setNewLandArray, callWorkFlowApi, viewOnly, userType } = useGrowerIndividulalContextData();
    const { t } = useTranslation();
    const uuid = localStorage.getItem('uuid');
    const navigate = useNavigate();
    const location = useLocation();
    const [landComment, setLandComment] = useState("");
    const [characterLimit] = useState(300);
    const [open, setOpen] = useState(() => {
        const initialState = {};
        newLandArray.forEach(obj => {
            initialState[obj.id] = false;
        });
        return initialState;
    });
    const [captiveStartDateDisplay, setCaptiveStartDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [captiveEndDateDisplay, setCaptiveEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [leaseStartDateDisplay, setLeaseStartDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [leaseEndDateDisplay, setLeaseEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [selectedLand, setSelectedLand] = useState();
    const [selectedLandId, setSelectedLandId] = useState();
    const [bambooSpecies, setBambooSpecies] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [editSpecies, setEditSpecies] = useState();
    const [speciesName, setSpeciesName] = useState();
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [loc, setLoc] = useState();
    const [documentDetails, setDocumentDetails] = useState({
        id: null,
        documentType: null,
        documentName: null,
        documentBlobName: null,
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: "growerland",
        stakeholderDetailId: null,
        isActive: 1
    });
    const [landAreaValue, setLandAreaValue] = useState('');
    const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [availableLandAreaValue, setAvailableLandAreaValue] = useState('');
    const [availableLandAreaUnit, setAvailableLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [addEditBtnName, setAddEditBtnName] = useState('');
    const [growerLandDetails, setGrowerLandDetails] = useState();
    const existingLand = landUpdatedDetails?.landArea?.split(' ')
    let updatedGrowerLandDetail =
    {
        "id": growerLandDetails?.id,
        "regGrowerMasterId": growerLandDetails?.regGrowerMasterId,
        "pincode": landUpdatedDetails?.pincode,
        "address": landUpdatedDetails?.address,
        "state": landUpdatedDetails?.state,
        "district": landUpdatedDetails?.district,
        "subDivision": landUpdatedDetails?.subDivision,
        "postOffice": growerLandDetails?.postOffice,
        "revenueCircle": landUpdatedDetails?.revenueCircle,
        "blockName": landUpdatedDetails?.blockName,
        "captive": landUpdatedDetails?.captive,
        "captiveStartDate": landUpdatedDetails?.captiveStartDate ? landUpdatedDetails?.captiveStartDate : moment(new Date()).format(API_DATE_FORMAT),
        "captiveEndDate": landUpdatedDetails?.captiveEndDate ? landUpdatedDetails?.captiveEndDate : moment(new Date()).format(API_DATE_FORMAT),
        "landArea": landAreaValue + " " + landAreaUnit,
        "availableLandArea": availableLandAreaValue + " " + availableLandAreaUnit,
        "totalNoOfBambooClumps": growerLandDetails?.totalNoOfBambooClumps,
        "landLeasedOwned": landUpdatedDetails?.landLeasedOwned ? landUpdatedDetails?.landLeasedOwned : 'Leased',
        "leaseStartDate": landUpdatedDetails?.leaseStartDate ? landUpdatedDetails?.leaseStartDate : moment(new Date()).format(API_DATE_FORMAT),
        "leaseEndDate": landUpdatedDetails?.leaseEndDate ? landUpdatedDetails?.leaseEndDate : moment(new Date()).format(API_DATE_FORMAT),
        "isPreregistrationShortlisted": growerLandDetails?.isPreregistrationShortlisted,
        "easeOfSourcing": landUpdatedDetails?.easeOfSourcing,
        "sidingRequirement": landUpdatedDetails?.sidingRequirement,
        "sidingDistanceInMtrs": landUpdatedDetails?.sidingDistanceInMtrs,
        "landType": landUpdatedDetails?.landType ? landUpdatedDetails?.landType : 'Hilly',
        "landName": landUpdatedDetails?.landName ? landUpdatedDetails?.landName : '',
        "cooperativeName": growerLandDetails?.cooperativeName,
        "cooperativeOwner": growerLandDetails?.cooperativeOwner,
        "coopLandLocation": growerLandDetails?.coopLandLocation,
        "govtAgencyName": growerLandDetails?.govtAgencyName,
        "govtAgencyIncharge": growerLandDetails?.govtAgencyIncharge,
        "locationGeocode": growerLandDetails?.locationGeocode,
        "createdOn": growerLandDetails?.createdOn,
        "createdBy": growerLandDetails?.createdBy,
        "updatedOn": growerLandDetails?.updatedOn,
        "updatedBy": growerLandDetails?.updatedBy,
        "isActive": 1,
        "growerBambooSpecies": landUpdatedDetails?.growerBambooSpecies,
        "growerLandDocuments": landUpdatedDetails?.growerLandDocuments,
        "geocodeLattitude": landUpdatedDetails?.geocodeLattitude,
        "geocodeLongitude": landUpdatedDetails?.geocodeLongitude,
        "aggregationPoint": landUpdatedDetails?.aggregationPoint,
        "aggregationPointName": landUpdatedDetails?.aggregationPointName,
        "aggregationPointAddress": landUpdatedDetails?.aggregationPointAddress,
        "aggregationPointPincode": landUpdatedDetails?.aggregationPointPincode,
        "aggregationPointState": landUpdatedDetails?.aggregationPointState,
        "aggregationPointDistrict": landUpdatedDetails?.aggregationPointDistrict,
        "aggregationPointBlockName": landUpdatedDetails?.aggregationPointBlockName,
        "aggregationPointRevenueCircle": landUpdatedDetails?.aggregationPointRevenueCircle,
        "aggregationGeocodeLattitude": landUpdatedDetails?.aggregationGeocodeLattitude,
        "aggregationGeocodeLongitude": landUpdatedDetails?.aggregationGeocodeLongitude,
    }
    let userRole = localStorage.getItem('role');
    useEffect(() => {
        getGrowerBambooSpecies();
    }, []);
    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (documentUploadDetails) {
            setDocumentDetails({ ...documentDetails, documentName: documentUploadDetails?.blobResponse?.fileName, documentBlobName: documentUploadDetails?.blobResponse?.blobFileName });
        }
    }, [documentUploadDetails]);

    useEffect(() => {
        if (documentDetails) {
            const remainingArr = (landUpdatedDetails?.growerLandDocuments)?.filter(item => item.documentType !== documentDetails.documentType);
            remainingArr?.push(documentDetails);
            setLandUpdatedDetails({ ...landUpdatedDetails, growerLandDocuments: remainingArr })
        }
    }, [documentDetails.documentBlobName]);


    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            setLoc(decoded_urn);
        }
    }, [getLocalStorageItem('id_token')]);

    function getDocumentUploadDetails() {
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "stakeholder");
        loaderService.showLoader();
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                loaderService.hideLoader();
                setDocumentUploadDetails(response.data);
            })

            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }

    const addLandBtnClick = (e) => {
        if (validateLandDetails()) {
            addEditBtnName === t('reg.addland') ? addLandCallback(updatedGrowerLandDetail, comments) : editLandCallback(updatedGrowerLandDetail)
        }
    }

    const addLandCallback = (updatedDetails, comments) => {
        setNewLandComments(comments.filter((item) => item.type === "New Land"))
        const remainingArr = newLandArray?.filter((item) => item.landName !== updatedDetails.landName);
        remainingArr.push(updatedDetails);
        setNewLandArray(remainingArr);
        setNewLandObject([])
        enableSaveSubmitButtons && setCallUpdateApi(true);
    }
    const deleteLandCallback = (landArray) => {
        setNewLandArray(landArray);
    }
    const editLandCallback = (updatedDetails) => {
        const remainingArr = newLandArray?.filter((item) => item.landName !== updatedDetails.landName);
        remainingArr.push(updatedDetails);
        setNewLandArray(remainingArr);
        setOpen((prevOpen) => ({
            ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false]))
        }));
    }


    const validateLandDetails = () => {
        if (!(ResourceUpdateMember.includes(userRole) && userRole === userRole.ItAdmin)) {
            if (!landUpdatedDetails?.address || landUpdatedDetails?.address.length == 0) {
                setErrorMessage({ ...errorMessage, addressError: "Please enter address" });
                toast.error("Please enter address");
                return false;
            }
            else if (!landUpdatedDetails.pincode) {
                setErrorMessage({ pincodeError: "Please enter pincode" });
                toast.error("Please enter pincode");
                return false;
            }

            else if (landUpdatedDetails.pincode.length !== 6) {
                setErrorMessage({ pincodeError: "Please enter a valid pincode" });
                toast.error("Please enter a valid pincode");
                return false;
            }
            else if (!landUpdatedDetails.state || landUpdatedDetails.state.length == 0) {
                setErrorMessage({ pincodeError: "Please search pincode" });
                toast.error("Please search pincode");
                return false;
            }
            else if (!landUpdatedDetails.blockName && !landUpdatedDetails.revenueCircle) {
                setErrorMessage({ blockNameError: "Please enter block office" });
                toast.error("Please enter block office");
                return false;
            }
            else if (landUpdatedDetails.captive && !landUpdatedDetails.captiveStartDate) {
                setErrorMessage({ captiveStartDateError: "Please enter captive start date" });
                toast.error("Please enter captive start date");
                return false;
            }
            else if (landUpdatedDetails.captive && !landUpdatedDetails.captiveEndDate) {
                setErrorMessage({ captiveEndDateError: "Please enter captive end date" });
                toast.error("Please enter captive end date");
                return false;
            }
            else if (landUpdatedDetails.captiveEndDate < landUpdatedDetails.captiveStartDate) {
                setErrorMessage({ captiveEndDateError: "captive end date can not be less than captive start date" });
                toast.error("captive end date can not be less than captive start date");
                return false;
            }
            else if (!landAreaValue) {
                setErrorMessage({ landAreaError: "Please enter land area" });
                toast.error("Please enter land area");
                return false;
            }
            else if (!availableLandAreaValue) {
                setErrorMessage({ availableLandAreaError: "Please enter available land area" });
                toast.error("Please enter available land area");
                return false;
            }
            else if (availableLandAreaValue == 0 && landAreaValue == 0) {
                setErrorMessage({ availableLandAreaError: "Either existing land area or avilable land area should be greater than 0" });
                toast.error("Either existing land area or avilable land area should be greater than 0");
                return false;
            }
            //else if (landAreaUnit !== availableLandAreaUnit) {
            //    setErrorMessage({ landAreaError: "Please select the same unit for both existing and available land area.", availableLandAreaError: "Please select the same unit for both existing and available land area." });
            //    toast.error("Please select the same unit for both existing and available land area.");
            //    return false;
            //}            
            //else if (Number(availableLandAreaValue) > Number(landAreaValue)) {
            //    setErrorMessage({ landAreaError: "Existing land area should be greater than available land area" });
            //    toast.error("Existing land area should be greater than available land area");
            //    return false;
            //}
            else if (landUpdatedDetails?.landLeasedOwned === "Leased" && !landUpdatedDetails.leaseStartDate) {
                setErrorMessage({ leaseStartDateError: "Please enter lease start date" });
                toast.error("Please enter lease start date");
                return false;
            }
            else if (landUpdatedDetails?.landLeasedOwned === "Leased" && !landUpdatedDetails.leaseEndDate) {
                setErrorMessage({ leaseEndDateError: "Please enter lease end date" });
                toast.error("Please enter lease end date");
                return false;
            }
            else if (landUpdatedDetails.leaseEndDate < landUpdatedDetails.leaseStartDate) {
                setErrorMessage({ leaseEndDateError: "lease end date can not be less than lease start date" });
                toast.error("lease end date can not be less than lease start date");
                return false;
            }
            else if (landUpdatedDetails.leaseStartDate && landUpdatedDetails.leaseEndDate && landUpdatedDetails.captiveStartDate && landUpdatedDetails.captiveEndDate
                && (landUpdatedDetails.captiveStartDate < landUpdatedDetails.leaseStartDate)) {
                setErrorMessage({ captiveEndDateError: "Captive land agreement start date should be greater than Leased Land Agreement start date" })
                toast.error("Captive land agreement start date should be greater than Leased Land Agreement start date");
                return false;
            }
            else if (!landUpdatedDetails.landName) {
                setErrorMessage({ landNameError: "Please enter land name" });
                toast.error("Please enter land name");
                return false;
            }
            else if (newLandArray.filter(item => landUpdatedDetails.landName === item.landName && item.isActive == 1).length > 0 && updatedGrowerLandDetail.id == null) {
                setErrorMessage({ ...errorMessage, landNameError: "Land name already exist" });
                toast.error("Land name already exist");
                return false;
            }
            else if (!landUpdatedDetails.easeOfSourcing) {
                setErrorMessage({ easeOfSourcingError: "Please enter ease of sourcing" });
                toast.error("Please enter ease of sourcing");
                return false;
            }
            else if (landUpdatedDetails?.sidingRequirement && !landUpdatedDetails?.sidingDistanceInMtrs) {
                setErrorMessage({ sidingDistanceInMtrsError: "Please enter siding distance" });
                toast.error("Please enter siding distance");
                return false;
            }
            else if ((growerDetails?.growers[0]?.growerType === 'INDIVIDUAL' && !landUpdatedDetails?.geocodeLattitude) || (growerDetails?.growers[0]?.growerType === 'JFMC' && localStorage.getItem('role') === ROLES.RegistrationScruitnizer && !landUpdatedDetails?.geocodeLattitude)) {
                setErrorMessage({ latitudesError: "Please enter latitude" });
                toast.error("Please enter latitude");
                return false;
            }
            else if ((growerDetails?.growers[0]?.growerType === 'INDIVIDUAL' && !landUpdatedDetails?.geocodeLongitude) || (growerDetails?.growers[0]?.growerType === 'JFMC' && localStorage.getItem('role') === ROLES.RegistrationScruitnizer && !landUpdatedDetails?.geocodeLongitude)) {
                setErrorMessage({ longitudesError: "Please enter longitude" });
                toast.error("Please enter longitude");
                return false;
            }
            else if ((existingLand[0] > 0) && (landUpdatedDetails.growerBambooSpecies.length < 1)) {
                toast.error("Please add bamboo species details");
                return false;
            }
            else if ((growerDetails?.growers[0]?.growerType === 'Individual' || growerDetails?.growers[0]?.growerType === 'Grower') && landUpdatedDetails?.aggregationPoint) {
                if (!landUpdatedDetails?.aggregationPointName) {
                    setErrorMessage({ aggregationNameError: "Please enter aggregation point name" });
                    toast.error("Please enter aggregation point name");
                    return false;
                }
                else if (!landUpdatedDetails.aggregationPointPincode) {
                    setErrorMessage({ aggregationPincodeError: "Please enter aggregation point pincode" });
                    toast.error("Please enter aggregation point pincode");
                    return false;
                }
                else if (landUpdatedDetails.aggregationPointPincode.length !== 6) {
                    setErrorMessage({ aggregationPincodeError: "Please enter a valid aggregation point pincode" });
                    toast.error("Please enter a valid aggregation point pincode");
                    return false;
                }
                else if (!landUpdatedDetails.aggregationPointState || landUpdatedDetails.aggregationPointState.length == 0) {
                    setErrorMessage({ aggregationPincodeError: "Please search aggregation point pincode" });
                    toast.error("Please search aggregation point pincode");
                    return false;
                }
                else if (!landUpdatedDetails.aggregationPointRevenueCircle && !landUpdatedDetails.aggregationPointBlockName) {
                    setErrorMessage({ aggregationrevenueCircleError: "Please enter revenue circle or block name" });
                    toast.error("Please enter revenue circle or block name");
                    return false;
                }
                else if (!landUpdatedDetails?.aggregationGeocodeLattitude) {
                    setErrorMessage({ aggregationLatitudesError: "Please enter aggregation point latitude" });
                    toast.error("Please enter aggregation point latitude");
                    return false;
                }
                else if (!landUpdatedDetails?.aggregationGeocodeLongitude) {
                    setErrorMessage({ aggregationLongitudesError: "Please enter aggregation point longitude" });
                    toast.error("Please enter aggregation point longitude");
                    return false;
                }

            }
            var landDoc = landUpdatedDetails?.growerLandDocuments && landUpdatedDetails?.growerLandDocuments.filter((item) => item.documentType === "LandLeasedOwned" && (item.isActive == 1 || item.isActive == 3));
            if (landDoc.length == 0 && growerDetails?.growers[0]?.growerType !== 'JFMC') {
                setErrorMessage({ landDocumentError: "Please upload grower land documents" });
                toast.error("Please upload grower land documents");
                return false;
            }
            var landpic = landUpdatedDetails?.growerLandDocuments && landUpdatedDetails?.growerLandDocuments.filter((item) => item.documentType === "LandPics" && (item.isActive == 1 || item.isActive == 3));
            if (landpic.length == 0 && growerDetails?.growers[0]?.growerType !== 'JFMC') {
                setErrorMessage({ landPicsError: "Please upload land image." });
                toast.error("Please upload land image.");
                return false;
            }
        }
        if (showCommentSection && !comments.find((item) => item.sectionName === "land_details" && item.sectionId === selectedLandId && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
            toast.error("Please enter comments for required sections");
            return false
        }
        return true;
    }

    const [newLandObject, setNewLandObject] = useState([]);
    const addnewLandBtnClick = (e) => {
        e.preventDefault();
        const tempId = "noId"
        newLandObject.length === 0 && setOpen((prevOpen) => ({
            ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false])),
            [tempId]: true
        }));
        setNewLandObject([
            {
                id: tempId,
                pincode: "-",
                landLeasedOwned: "-",
                landType: "-",
                landName: "-",
                growerBambooSpecies: []
            }
        ])
        setGrowerLandDetails('');
        setSelectedLand('');
        setSelectedLandId(uuidv4())
        setLandAreaUnit('sq ft');
        setLandAreaValue('');
        setAvailableLandAreaUnit('sq ft');
        setAvailableLandAreaValue('');
        setLeaseStartDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setLeaseEndDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setCaptiveStartDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setCaptiveEndDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setLandUpdatedDetails({
            ...landUpdatedDetails, address: '',
            // id: selectedLandId,
            pincode: '',
            state: '',
            district: '',
            subDivision: '',
            selectedRevenueCircle: '',
            selectedBlockName: '',
            captive: true,
            captiveStartDate: moment(new Date()).format(API_DATE_FORMAT),
            captiveEndDate: moment(new Date()).format(API_DATE_FORMAT),
            landArea: '',
            landAreaValue: '',
            landAreaUnit: 'sq ft',
            availableLandArea: '',
            availableLandAreaValue: '',
            availableLandAreaUnit: 'sq ft',
            landLeasedOwned: 'Leased',
            leaseStartDate: moment(new Date()).format(API_DATE_FORMAT),
            leaseEndDate: moment(new Date()).format(API_DATE_FORMAT),
            landType: 'Hilly',
            easeOfSourcing: '',
            sidingRequirement: true,
            sidingDistanceInMtrs: '',
            growerBambooSpecies: [],
            regGrowerMasterId: '',
            growerLandDocuments: [],
            landName: '',
            geocodeLattitude: '',
            geocodeLongitude: '',
            aggregationPoint: true,
            aggregationPointName: '',
            aggregationPointAddress: '',
            aggregationPointPincode: '',
            aggregationPointState: '',
            aggregationPointDistrict: '',
            aggregationPointBlockName: '',
            aggregationPointRevenueCircle: '',
            aggregationGeocodeLattitude: '',
            aggregationGeocodeLongitude: '',
        });
        setAddEditBtnName(t('reg.addland'))
    }
    const editBtnClick = (e, item) => {
        setSelectedLand(item?.landName);
        setSelectedLandId(item?.id);
        let selectedLandDetails = newLandArray && newLandArray?.filter(item1 => item1?.landName === item?.landName && (item1.isActive == 1 || item1.isActive == 3));
        setGrowerLandDetails(selectedLandDetails[0]);
        setErrorMessage({ landAreaError: "", availableLandAreaError: "" })
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            address: selectedLandDetails[0]?.address,
            pincode: selectedLandDetails[0]?.pincode,
            state: selectedLandDetails[0]?.state,
            district: selectedLandDetails[0]?.district,
            subDivision: selectedLandDetails[0]?.subDivision,
            revenueCircle: selectedLandDetails[0]?.revenueCircle,
            blockName: selectedLandDetails[0]?.blockName,
            captive: selectedLandDetails[0]?.captive,
            captiveStartDate: selectedLandDetails[0]?.captiveStartDate ? selectedLandDetails[0]?.captiveStartDate : moment(new Date()).format(API_DATE_FORMAT),
            captiveEndDate: selectedLandDetails[0]?.captiveEndDate ? selectedLandDetails[0]?.captiveEndDate : moment(new Date()).format(API_DATE_FORMAT),
            landArea: selectedLandDetails[0]?.landArea,
            availableLandArea: selectedLandDetails[0]?.availableLandArea,
            landLeasedOwned: selectedLandDetails[0]?.landLeasedOwned ? selectedLandDetails[0]?.landLeasedOwned : 'Leased',
            leaseStartDate: selectedLandDetails[0]?.leaseStartDate ? selectedLandDetails[0]?.leaseStartDate : moment(new Date()).format(API_DATE_FORMAT),
            leaseEndDate: selectedLandDetails[0]?.leaseEndDate ? selectedLandDetails[0]?.leaseEndDate : moment(new Date()).format(API_DATE_FORMAT),
            landType: selectedLandDetails[0]?.landType ? selectedLandDetails[0]?.landType : 'Hill',
            landName: selectedLandDetails[0]?.landName ? selectedLandDetails[0]?.landName : '',
            easeOfSourcing: selectedLandDetails[0]?.easeOfSourcing,
            sidingRequirement: selectedLandDetails[0]?.sidingRequirement,
            sidingDistanceInMtrs: selectedLandDetails[0]?.sidingDistanceInMtrs,
            growerBambooSpecies: selectedLandDetails[0]?.growerBambooSpecies ? selectedLandDetails[0]?.growerBambooSpecies : [],
            landDetailsId: selectedLandDetails[0]?.id,
            growerLandDocuments: selectedLandDetails[0]?.growerLandDocuments,
            geocodeLattitude: selectedLandDetails[0]?.geocodeLattitude,
            geocodeLongitude: selectedLandDetails[0]?.geocodeLongitude,
            aggregationPoint: selectedLandDetails[0]?.aggregationPoint,
            aggregationPointName: selectedLandDetails[0]?.aggregationPointName,
            aggregationPointAddress: selectedLandDetails[0]?.aggregationPointAddress,
            aggregationPointPincode: selectedLandDetails[0]?.aggregationPointPincode,
            aggregationPointState: selectedLandDetails[0]?.aggregationPointState,
            aggregationPointDistrict: selectedLandDetails[0]?.aggregationPointDistrict,
            aggregationPointBlockName: selectedLandDetails[0]?.aggregationPointBlockName,
            aggregationPointRevenueCircle: selectedLandDetails[0]?.aggregationPointRevenueCircle,
            aggregationGeocodeLattitude: selectedLandDetails[0]?.aggregationGeocodeLattitude,
            aggregationGeocodeLongitude: selectedLandDetails[0]?.aggregationGeocodeLongitude,

        })
        const spaceIndex = selectedLandDetails[0].landArea?.indexOf(" ");
        const availableLandSpaceIndex = selectedLandDetails[0].availableLandArea?.indexOf(" ");
        const numberPart = selectedLandDetails[0].landArea?.slice(0, spaceIndex);
        const unitPart = selectedLandDetails[0].landArea?.slice(spaceIndex + 1);
        const availableLandNumberPart = selectedLandDetails[0].availableLandArea?.slice(0, availableLandSpaceIndex);
        const availableLandUnitPart = selectedLandDetails[0].availableLandArea?.slice(availableLandSpaceIndex + 1);
        setLandAreaValue(numberPart);
        setLandAreaUnit(unitPart);
        setAvailableLandAreaValue(availableLandNumberPart);
        setAvailableLandAreaUnit(availableLandUnitPart);
        setCaptiveStartDateDisplay(selectedLandDetails[0]?.captiveStartDate ? moment(selectedLandDetails[0]?.captiveStartDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setCaptiveEndDateDisplay(selectedLandDetails[0]?.captiveEndDate ? moment(selectedLandDetails[0]?.captiveEndDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setLeaseStartDateDisplay(selectedLandDetails[0]?.leaseStartDate ? moment(selectedLandDetails[0]?.leaseStartDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setLeaseEndDateDisplay(selectedLandDetails[0]?.leaseEndDate ? moment(selectedLandDetails[0]?.leaseEndDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setAddEditBtnName(t('reg.updateLand'));
    }

    const onUploadCallBack = (docArray) => {

        setLandUpdatedDetails({ ...landUpdatedDetails, growerLandDocuments: docArray });

        var landDocument = docArray.filter((item) => item.documentType === "LandLeasedOwned" && (item.isActive == 1 || item.isActive == 3));
        if (landDocument.length > 0) {
            setErrorMessage({ errorMessage, landDocumentError: "" });
        }
    }
    const handleChange = (e) => {
        if (e.target.name === "pincode") {
            if (e.target.value.length !== 6) {
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: pincodeValidation(e.target.value) })
                setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            } else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
        else if (e.target.name === 'landName') {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) })
            if (e.target.value.length > 0) {
                if (newLandArray.some(item => e.target.value === item.landName && item.isActive == 1)) {
                    setErrorMessage({ ...errorMessage, landNameError: "Land name already exist" });
                } else {
                    setErrorMessage({ ...errorMessage, landNameError: '' });
                }
            } else setErrorMessage({ ...errorMessage, landNameError: EMPTY_FIELD_ERROR });

        }
        else if (e.target.name === 'address') {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) })
            if ((e.target.value).length > 0 && VALIDATION.noSpecialCharacterValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, addressError: "" });
            } else {
                setErrorMessage({ ...errorMessage, addressError: "Please enter address" })

            }
        }
        else if (e.target.name === "landAreaValue") {
            var slicedLandArea = landAreaValidation(e.target.value);
            setLandAreaValue(slicedLandArea);
            if (slicedLandArea.length == 0) {
                setErrorMessage({ ...errorMessage, landAreaError: LAND_AREA_ERROR });
            }
            else setErrorMessage({ ...errorMessage, landAreaError: "" });
            setLandUpdatedDetails({ ...landUpdatedDetails, "landArea": slicedLandArea + ' ' + landAreaUnit });
        }
        else if (e.target.name === "landAreaUnit") {
            setLandAreaUnit(e.target.value);
            setLandUpdatedDetails({ ...landUpdatedDetails, "landArea": landAreaValue + ' ' + e.target.value });
        }
        else if (e.target.name === "availableLandAreaValue") {
            var slicedAvailableLandArea = landAreaValidation(e.target.value);
            setAvailableLandAreaValue(slicedAvailableLandArea);
            if (slicedAvailableLandArea.length == 0) {
                setErrorMessage({ ...errorMessage, availableLandAreaError: LAND_AREA_ERROR });
            }
            else setErrorMessage({ ...errorMessage, availableLandAreaError: "" });
            setLandUpdatedDetails({ ...landUpdatedDetails, "availableLandArea": slicedAvailableLandArea + ' ' + availableLandAreaUnit });
        }
        else if (e.target.name === "availableLandAreaUnit") {
            setAvailableLandAreaUnit(e.target.value);
            setLandUpdatedDetails({ ...landUpdatedDetails, "availableLandArea": availableLandAreaValue + ' ' + e.target.value });
        }
        else if (e.target.name === 'easeOfSourcing') {
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, easeOfSourcingError: "" });
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value })
            } else setErrorMessage({ ...errorMessage, easeOfSourcingError: EMPTY_FIELD_ERROR });
        }
        else if (e.target.name === 'sidingDistanceInMtrs') {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value.slice(0, 5) })
            if (e.target.value.length > 0) {
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value.slice(0, 5) })
                setErrorMessage({ ...errorMessage, sidingDistanceInMtrsError: "" });
            } else setErrorMessage({ ...errorMessage, sidingDistanceInMtrsError: EMPTY_FIELD_ERROR });
        }
        else if (e.target.name === 'aggregationPointName') {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) })
            if (e.target.value.length == 0) {
                setErrorMessage({ ...errorMessage, aggregationNameError: 'Please enter aggregation point name' });
            } else setErrorMessage({ ...errorMessage, aggregationNameError: '' });
        }
        else if (e.target.name === "aggregationPointPincode") {
            if (e.target.value.length !== 6) {
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: pincodeValidation(e.target.value) })
                setErrorMessage({ ...errorMessage, aggregationPincodeError: PINCODE_NO_ERROR });
            } else setErrorMessage({ ...errorMessage, aggregationPincodeError: "" });
        }
        else {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value })
        }
    };
    const radioChange = (e, value) => {
        setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: value })
    };
    const handleDateChange = (e, name) => {
        // e.preventDefault();
        let date = e.format("YYYY-MM-DD");
        let formattedDate = moment(date).format(API_DATE_FORMAT)
        setLandUpdatedDetails({ ...landUpdatedDetails, [name]: formattedDate })
        if (name == "captiveStartDate")
            setCaptiveStartDateDisplay(date);
        else if (name == "captiveEndDate")
            setCaptiveEndDateDisplay(date);
        else if (name == "leaseStartDate")
            setLeaseStartDateDisplay(date);
        else if (name == "leaseEndDate")
            setLeaseEndDateDisplay(date);
    }
    const bambooSpeciesSubmitCallbackFunction = (bambooSpeciesDetails, onClose) => {
        let remainingArr = bambooSpecies && (landUpdatedDetails?.growerBambooSpecies)?.filter(item => (item.bambooSpecies !== bambooSpeciesDetails.bambooSpecies || item.otherBambooSpecies !== bambooSpeciesDetails.otherBambooSpecies));
        remainingArr?.push(bambooSpeciesDetails);
        setLandUpdatedDetails({ ...landUpdatedDetails, growerBambooSpecies: remainingArr })
        onClose();
    }

    const addBamboo = (e, selectedSpecies, otherSpeciesName) => {
        setEditSpecies(selectedSpecies)
        setSpeciesName(otherSpeciesName)
        handleLogModalOpen();
    }

    const onDeleteLand = (selectedItem) => {
        const tempArr = (newLandArray?.map(item => {
            if (item.landName === selectedItem.landName) {
                item.isActive = 0
            }
            return item
        }
        ))
        deleteLandCallback(tempArr);
    };

    const onDeleteSpecies = (id, speciesName) => {
        const updatedBambooSpecies = ((landUpdatedDetails?.growerBambooSpecies).map(item => {
            if (item.bambooSpecies === id && item.otherBambooSpecies === speciesName) {
                item.isActive = 0
            }
            return item
        }
        ))
        setLandUpdatedDetails({ ...landUpdatedDetails, growerBambooSpecies: updatedBambooSpecies });
    };
    const getUpdatedAddressData = (data) => {
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,
        })
        setErrorMessage({ ...errorMessage, blockNameError: "" });
    }
    const getAggregationUpdatedAddressData = (data) => {
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            aggregationPointPincode: data.pincode,
            aggregationPointState: data.pincodeState,
            aggregationPointDistrict: data.pincodeDistrict,
            aggregationPointSubDivision: data.pincodeSubDivision,
            aggregationPointRevenueCircle: data.selectedRevenueCircle,
            aggregationPointBlockName: data.selectedBlockName,
        })
        setErrorMessage({ ...errorMessage, aggregationrevenueCircleError: "" });
    }

    const onLocationPoint = (position) => {
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            geocodeLattitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
            geocodeLongitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
        });

        setErrorMessage({ latitudesError: "", longitudesError: "" })
    }



    const onAggregationLocationPoint = (position) => {

        setLandUpdatedDetails({
            ...landUpdatedDetails,
            aggregationGeocodeLattitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
            aggregationGeocodeLongitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
        });
        setErrorMessage({ aggregationLatitudesError: "", aggregationLongitudesError: "" })
    }

    function getGrowerBambooSpecies() {
        loaderService.showLoader();
        apiClient
            .post(GET_GROWER_BAMBOO_SPECIES,
                {
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setBambooSpecies(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setLandUpdatedDetails({ ...landUpdatedDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setLandUpdatedDetails({ ...landUpdatedDetails, revenueCircle: e.target.value, });
        }
    }
    const handleChangeSelectAggregation = (e, type) => {
        if (type == BLOCK_LIST) {
            setLandUpdatedDetails({ ...landUpdatedDetails, aggregationPointBlockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setLandUpdatedDetails({ ...landUpdatedDetails, aggregationPointRevenueCircle: e.target.value, });
        }
    }

    const columns = [
        {
            field: 'speciesType',
            headerName: t('reg.speciesType'),
            width: 130,
            renderCell: params => (bambooSpeciesRes?.filter(a => a.id === params.row.bambooSpecies)[0].value) + (params.row.otherBambooSpecies ? " - " + params.row.otherBambooSpecies : "")
        },
        {
            field: 'noOfClumps',
            headerName: t('reg.noOfClumps'),
            width: 130,
            type: "number"
        },
        {
            field: 'avgClumpSize',
            headerName: t('reg.avgClumpSize'),
            width: 130,
            type: "number"
        },
        {
            field: 'avgPoleWeight',
            headerName: t('reg.avgWeightOfBambooPole'),
            width: 170,
            type: "number"
        },
        //{
        //    field: 'otherBambooSpecies',
        //    headerName: t('reg.speciesName'),
        //    width: 130
        //},
        {
            field: 'totalQuantity',
            headerName: t('reg.totalBambooQuantity'),
            width: 150,
            type: "number",
            renderCell: params => (params.row.noOfClumps * params.row.avgClumpSize * params.row.avgPoleWeight) / 1000
        },
        {

            field: 'committedNoOfClumps',
            headerName: t('reg.committedQuantity'),
            width: 150,
            type: "number",
            renderHeader: (params) => (

                <strong>{t('reg.committedQuantity')}</strong>

            ),

        },
        {
            field: 'actions',
            headerName: t('reg.actions'),
            type: 'action',
            width: 150,
            renderCell: (params) => {
                return (
                    <>
                        <Button onClick={(e) => addBamboo(e, bambooSpeciesRes?.filter(a => a.id === params.row.bambooSpecies)[0].value, params.row.otherBambooSpecies)}>{enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true) ? t('reg.edit') : t('reg.view')}</Button>
                        {enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true) && 
                        <Tooltip title="Delete">
                        <IconButton size='small' color="error"
                            onClick={() => onDeleteSpecies(params.row.bambooSpecies, params.row.otherBambooSpecies)} >
                            <DeleteIcon color='error' fontSize='small' />
                        </IconButton>
                        </Tooltip>}
                    </>
                )
            }
        },

    ]

    const onSaveComment = (comment) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: "land_details",
            sectionId: selectedLandId,
            sectionOk: landDetailsSectionOk[selectedLandId],
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
        }
        const newLandCommentObject = {
            id: uuidv4(),
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: "land_details",
            sectionId: selectedLandId,
            sectionOk: landDetailsSectionOk[selectedLandId],
            userRole: localStorage.getItem('role'),
            type: "New Land",
            landName: !selectedLand ? landUpdatedDetails?.landName : newLandArray.find((item) => item.id === selectedLandId),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
            createdByName: comments?.find((item) => item.sectionName === "personal_details")?.createdByName,
            createdOnFormatted: moment(new Date()).format("DD-MM-YYYY hh:mm a"),
            workflowStepDetailsId: null
        }
        if (comment) {
            if (!selectedLand) {
                const tempArr = [...comments]
                tempArr.push(newLandCommentObject)
                setComments(tempArr);
            }
            else insertComment([commentObject], growerDetails?.growers[0]?.regStakeholderMasterId, setCommentsData)
        }
        else toast.error("Please enter comment");
        setLandComment("")
        setErrorMessage({ ...errorMessage, landCommentError: "" });

    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    return (
        <>
            <Grid item xs={12}>
                <Accordion mt={1} expanded={expandedSection === "land"}
                    onChange={(event, expanded) => {
                        setExpandedSection(expanded ? "land" : "");
                    }}>
                    <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (Object.values(landDetailsSectionOk).every(value => value === true) && Object.values(landDetailsSectionOk).length > 0 ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                        <Stack ml={2} display="flex" alignItems="center" direction="row">
                            {showCommentSection && !regScruResourceUpdate && (Object.values(landDetailsSectionOk).every(value => value === true) && Object.values(landDetailsSectionOk).length > 0 ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                            <Typography variant="subtitle1" >{t('reg.land details')}</Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>

                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                {!showWorkFlowButtons && !showClarificationButton && <Button onClick={(e) => addnewLandBtnClick(e)} disabled={!enableSaveSubmitButtons || viewOnly} variant="contained" startIcon={<AddIcon />}>
                                    {t('reg.addNewLand')}
                                </Button>}
                            </Stack>
                        </Stack>
                        <TableContainer component={Paper}>
                            <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell >{t('preReg.pincode')}</TableCell>
                                        <TableCell>{t('reg.land') + ' ' + t('preReg.owned') + '/' + t('preReg.lease')}</TableCell>
                                        <TableCell>{t('reg.landType')}</TableCell>
                                        <TableCell>{t('reg.landName')}</TableCell>
                                        <TableCell>{t('reg.totalBambooQuantity')}</TableCell>
                                        <TableCell>{t('reg.committedQuantity')}</TableCell>
                                        <TableCell>{t('reg.actions')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {newLandObject.concat(newLandArray.filter((item1) => (item1.isActive === 1 || item1.isActive === 3))).map((row) => (
                                        <>
                                            <TableRow sx={{ '& > *': { borderBottom: 'unset', backgroundColor: showCommentSection && !regScruResourceUpdate ? (landDetailsSectionOk[row.id] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" } }}>
                                                <TableCell>
                                                    <IconButton
                                                        aria-label="expand row"
                                                        size="small"
                                                        onClick={(e) => {
                                                            setOpen((prevOpen) => ({
                                                                ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false])),
                                                                [row.id]: !prevOpen[row.id],
                                                            }));
                                                            row.id === "noId" ? addnewLandBtnClick(e) : editBtnClick(e, row);
                                                        }}
                                                    >
                                                        {open[row.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        {showCommentSection && !regScruResourceUpdate && (landDetailsSectionOk[row.id] ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginLeft: "2vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginLeft: "2vh" }} />)}
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell>{row.pincode}</TableCell>
                                                <TableCell>{row.landLeasedOwned}</TableCell>
                                                <TableCell>{row.landType}</TableCell>
                                                <TableCell>{row.landName}</TableCell>
                                                <TableCell>{row?.growerBambooSpecies.reduce((a, v) => a = a + ((v.noOfClumps * v.avgClumpSize * v.avgPoleWeight) / 1000), 0)}</TableCell>
                                                <TableCell>{row?.growerBambooSpecies.reduce((a, v) => a = a + ((v.committedNoOfClumps * 1)), 0)}</TableCell>
                                                <TableCell> <>
                                                    {/* <Button onClick={(e) => editBtnClick(e, row)}
                                                    >{enableFieldFunction(shouldActOnSectionLand[row.id], false, false) ? "Edit" : "View"}</Button> */}
                                                    {enableFieldFunction(shouldActOnSectionLand[row.id], false, false) && 
                                                    <Tooltip title="Delete">
                                                    <IconButton size='small' color="error" aria-label="search"
                                                        onClick={() => onDeleteLand(row)} >
                                                        <DeleteIcon color='error' fontSize='small' />
                                                    </IconButton>
                                                    </Tooltip>}
                                                </></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                                                    <Collapse in={open[row.id]} timeout="auto" unmountOnExit>
                                                        <Grid container pb={3} pr={4} spacing={2} direction="row" sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (landDetailsSectionOk[selectedLandId] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "105%" }}>
                                                            <Grid item xs={12} style={{ marginBottom: "1em" }} alignItems="center">
                                                                <Stack direction="row" alignItems="center">
                                                                    <Typography variant="h6" mt={3}>
                                                                        {t('reg.land details')}
                                                                    </Typography>
                                                                </Stack>
                                                            </Grid>
                                                            <Grid item xs={12} lg={4}>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Address of the bamboo plantation land" arrow>
                                                                            <TextField fullWidth
                                                                                required
                                                                                multiline
                                                                                error={errorMessage?.addressError}
                                                                                helperText={errorMessage?.addressError}
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                type="input"
                                                                                label={t('main.address')}
                                                                                name="address"
                                                                                value={landUpdatedDetails?.address}
                                                                                onChange={(e) => handleChange(e)}

                                                                            />
                                                                            </Tooltip>
                                                                             <BadgeComponent currentLength={landUpdatedDetails?.address?.length} maxLength={addressMaxLength} />
                                                                       
                                                                    </Grid>
                                                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                                                        isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                        pincode={landUpdatedDetails?.pincode}
                                                                        state={landUpdatedDetails?.state}
                                                                        district={landUpdatedDetails?.district}
                                                                        revenueCircle={landUpdatedDetails?.revenueCircle}
                                                                        blockName={landUpdatedDetails?.blockName}
                                                                        onHandleCallback={getUpdatedAddressData}
                                                                        pincodeError={errorMessage.pincodeError}
                                                                        blockNameError={errorMessage.blockNameError}
                                                                        searchError={errorMessage.searchError}
                                                                        handleChangeSelect={handleChangeSelect}
                                                                    />
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Owned or controlled by another party" arrow>
                                                                            <FormControl className='label_grower_reg' required>
                                                                                <FormLabel>{t('reg.captive')}</FormLabel>
                                                                                <RadioGroup
                                                                                    row
                                                                                >
                                                                                    <FormControlLabel control={<Radio name="captive" checked={landUpdatedDetails?.captive === true} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => radioChange(e, true)} />} label={t('preReg.yes')} />
                                                                                    <FormControlLabel control={<Radio name="captive" checked={landUpdatedDetails?.captive === false} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => radioChange(e, false)} />} label={t('preReg.no')} />
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={6} hidden={!landUpdatedDetails?.captive}>

                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DesktopDatePicker fullWidth
                                                                                required
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                label={t('reg.startDate')}
                                                                                inputFormat="DD/MM/YYYY"
                                                                                value={captiveStartDateDisplay}
                                                                                name="captiveStartDate"
                                                                                onChange={(e) => handleDateChange(e, "captiveStartDate")}
                                                                                renderInput={(params) => <TextField {...params} />}
                                                                            />
                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.captiveStartDateError}</FormHelperText>
                                                                        </LocalizationProvider>

                                                                    </Grid>
                                                                    <Grid item xs={6} hidden={!landUpdatedDetails?.captive}>

                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DesktopDatePicker
                                                                                required
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                label={t('reg.endDate')}
                                                                                inputFormat="DD/MM/YYYY"
                                                                                value={captiveEndDateDisplay}
                                                                                minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                                                name="captiveEndDate"
                                                                                onChange={(e) => handleDateChange(e, "captiveEndDate")}
                                                                                renderInput={(params) => <TextField {...params} />}
                                                                            />
                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.captiveEndDateError}</FormHelperText>
                                                                            {captiveEndDateDisplay < moment(new Date()).format(BASIC_DATE_FORMAT) && <FormHelperText sx={{ color: 'red' }}>End date has already passed</FormHelperText>}
                                                                        </LocalizationProvider>

                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Area with bamboo plant" arrow>
                                                                            <TextField fullWidth
                                                                                required
                                                                                error={errorMessage.landAreaError}
                                                                                helperText={errorMessage.landAreaError}
                                                                                type="number"
                                                                                onFocus={handleNumberFieldFocus}
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                label={t('preReg.existingLandArea')}
                                                                                name="landAreaValue"
                                                                                value={landAreaValue}
                                                                                onChange={(e) => handleChange(e)}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <Select
                                                                                            variant="standard"
                                                                                            size="small"
                                                                                            name="landAreaUnit"
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                            value={landAreaUnit}
                                                                                            onChange={(e) => handleChange(e)}
                                                                                        >
                                                                                            {LAND_AREA_UNIT.map((option) => (
                                                                                                <MenuItem key={option} value={option}>
                                                                                                    {option}
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                        </Select>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Area available for bamboo plantation" arrow>
                                                                            <TextField fullWidth
                                                                                required
                                                                                error={errorMessage.availableLandAreaError}
                                                                                helperText={errorMessage.availableLandAreaError}
                                                                                type="number"
                                                                                onFocus={handleNumberFieldFocus}
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                label={t('preReg.availableLandArea')}
                                                                                name="availableLandAreaValue"
                                                                                value={availableLandAreaValue}
                                                                                onChange={(e) => handleChange(e)}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <Select
                                                                                            variant="standard"
                                                                                            size="small"
                                                                                            name="availableLandAreaUnit"
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                            value={availableLandAreaUnit}
                                                                                            onChange={(e) => handleChange(e)}
                                                                                        >
                                                                                            {LAND_AREA_UNIT.map((option) => (
                                                                                                <MenuItem key={option} value={option}>
                                                                                                    {option}
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                        </Select>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Land owned or leased" arrow>
                                                                            <FormControl required>
                                                                                <FormLabel>{t('reg.land')}</FormLabel>
                                                                                <RadioGroup
                                                                                    defaultValue="Leased"
                                                                                    row
                                                                                >
                                                                                    <FormControlLabel value="Leased" control={<Radio name="landLeasedOwned" checked={landUpdatedDetails?.landLeasedOwned === "Leased"} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => handleChange(e)} />} label={t('preReg.lease')} />
                                                                                    <FormControlLabel value="Owned" control={<Radio name="landLeasedOwned" checked={landUpdatedDetails?.landLeasedOwned === "Owned"} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => handleChange(e)} />} label={t('preReg.owned')} />
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={6} hidden={landUpdatedDetails?.landLeasedOwned == "Owned"}>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DesktopDatePicker fullWidth
                                                                                required
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                inputFormat="DD/MM/YYYY"
                                                                                label={t('reg.startDate')}
                                                                                value={leaseStartDateDisplay}
                                                                                onChange={(e) => handleDateChange(e, "leaseStartDate")}
                                                                                renderInput={(params) => <TextField {...params} />}
                                                                            />
                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.leaseStartDateError}</FormHelperText>
                                                                        </LocalizationProvider>
                                                                    </Grid>
                                                                    <Grid item xs={6} hidden={landUpdatedDetails?.landLeasedOwned == "Owned"}>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DesktopDatePicker fullWidth
                                                                                required
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                inputFormat="DD/MM/YYYY"
                                                                                value={leaseEndDateDisplay}
                                                                                label={t('reg.endDate')}
                                                                                minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                                                onChange={(e) => handleDateChange(e, "leaseEndDate")}
                                                                                renderInput={(params) => <TextField {...params} />}
                                                                            />
                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.leaseEndDateError}</FormHelperText>
                                                                            {leaseEndDateDisplay < moment(new Date()).format(BASIC_DATE_FORMAT) && <FormHelperText sx={{ color: 'red' }}>End date has already passed</FormHelperText>}
                                                                        </LocalizationProvider>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <FileUploadMUI key="LandLeasedOwned"
                                                                            documentList={landUpdatedDetails?.growerLandDocuments}
                                                                            documentType="LandLeasedOwned"
                                                                            callBackDocumentUpload={onUploadCallBack}
                                                                            stakeholderDetailId={growerDetails?.growers[0]?.growerLandDetails[0]?.id}
                                                                            title={landUpdatedDetails?.landLeasedOwned === "Owned" ? t('reg.uploadOwnedLandDoc') : t('reg.leaseAgreement')}
                                                                            stakeHolderType="grower"
                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                            errorMessage={errorMessage}
                                                                            setErrorMessage={setErrorMessage}
                                                                            documentError="landDocumentError"
                                                                        />
                                                                        {/* <div className='mandatory_field'>{errorMessage.landDocumentError}</div> */}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} lg={4}>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Unique name for land identification" arrow>
                                                                            <TextField fullWidth
                                                                                required
                                                                                error={errorMessage?.landNameError}
                                                                                helperText={errorMessage?.landNameError}
                                                                                name="landName"
                                                                                onChange={(e) => handleChange(e)}
                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true) || (addEditBtnName === t('reg.updateLand')) ? true : false}
                                                                                value={landUpdatedDetails?.landName}
                                                                                label={t('reg.landName')} />
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Terrain of the bamboo plot" arrow>
                                                                            <FormControl required>
                                                                                <FormLabel>{t('reg.landType')}</FormLabel>
                                                                                <RadioGroup
                                                                                    row
                                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                    name="row-radio-buttons-group"
                                                                                >
                                                                                    <FormControlLabel value="Hilly" control={<Radio className='label_grower_reg' name="landType" checked={landUpdatedDetails?.landType === "Hilly"} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => handleChange(e)} />} label={t('reg.hilly')} />
                                                                                    <FormControlLabel value="Plain" control={<Radio className='label_grower_reg' name="landType" checked={landUpdatedDetails?.landType === "Plain"} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => handleChange(e)} />} label={t('reg.plain')} />
                                                                                    <FormControlLabel value="Trench" control={<Radio className='label_grower_reg' name="landType" checked={landUpdatedDetails?.landType === "Trench"} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => handleChange(e)} />} label={t('reg.trench')} />
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Difficulty in harvesting and transportation" arrow>
                                                                            <FormControl fullWidth required error={errorMessage?.easeOfSourcingError}>
                                                                                <InputLabel>{t('reg.easeOfSourcing')}</InputLabel>
                                                                                <Select
                                                                                    label={t('reg.easeOfSourcing')}
                                                                                    name="easeOfSourcing"
                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                    value={landUpdatedDetails?.easeOfSourcing || ""}
                                                                                    onChange={(e) => handleChange(e)}>
                                                                                    {
                                                                                        SOURCING?.map((item) =>
                                                                                            <MenuItem value={item}>{item}</MenuItem>
                                                                                        )
                                                                                    }
                                                                                </Select>
                                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.easeOfSourcingError}</FormHelperText>
                                                                            </FormControl>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Tooltip title="Distance from road connectivity" arrow>
                                                                            <FormControl required>
                                                                                <FormLabel>{t('reg.sidingRequirement')}</FormLabel>
                                                                                <RadioGroup
                                                                                    row
                                                                                >
                                                                                    <FormControlLabel control={<Radio name="sidingRequirement" checked={landUpdatedDetails?.sidingRequirement === true} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => radioChange(e, true)} />} label={t('preReg.yes')} />
                                                                                    <FormControlLabel control={<Radio name="sidingRequirement" checked={landUpdatedDetails?.sidingRequirement === false} disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onChange={(e) => radioChange(e, false)} />} label={t('preReg.no')} />
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    {landUpdatedDetails?.sidingRequirement === true && <Grid item xs={12}>
                                                                        <Typography variant='caption' color="rgba(0, 0, 0, 0.6)" fontSize="2.4vh" gutterBottom>{t('reg.distanceInMetersForLoading')}</Typography>
                                                                        <TextField fullWidth sx={{ marginTop: "3vh" }}
                                                                            required
                                                                            error={errorMessage?.sidingDistanceInMtrsError}
                                                                            helperText={errorMessage?.sidingDistanceInMtrsError}
                                                                            label={t('reg.sidingDistance')}
                                                                            name="sidingDistanceInMtrs"
                                                                            type="number" onFocus={handleNumberFieldFocus} onKeyDown={(evt) => typeNumberValid(evt)}
                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                            value={landUpdatedDetails?.sidingDistanceInMtrs}
                                                                            onChange={(e) => handleChange(e)} />
                                                                    </Grid>}
                                                                    <Grid item xs={12} mt={1}>
                                                                            <LocationPointMUI
                                                                                latitudeLabel="Latitude"
                                                                                longitudeLabel="Longitude"
                                                                                latitudeName={t('preReg.latitude')}
                                                                                longitudeName={t('preReg.longitude')}
                                                                                latitude={landUpdatedDetails?.geocodeLattitude}
                                                                                longitude={landUpdatedDetails?.geocodeLongitude}
                                                                                callBackLocation={onLocationPoint}
                                                                                latitudesError={errorMessage.latitudesError}
                                                                                longitudesError={errorMessage.longitudesError}
                                                                                isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true, growerDetails?.growers[0]?.growerType === 'JFMC' && true)}
                                                                            />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <FileUploadMUI key="LandPics"
                                                                            documentList={landUpdatedDetails?.growerLandDocuments}
                                                                            documentType="LandPics"
                                                                            callBackDocumentUpload={onUploadCallBack}
                                                                            stakeholderDetailId={growerDetails?.growers[0]?.growerLandDetails[0]?.id}
                                                                            title={t('preReg.uploadPlotImageWithTimeLocationStamp')}
                                                                            stakeHolderType="growerLand"
                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true, growerDetails?.growers[0]?.growerType === 'JFMC' && true)}
                                                                            errorMessage={errorMessage}
                                                                            setErrorMessage={setErrorMessage}
                                                                            documentError="landPicsError"
                                                                       />
                                                                        {/* <div className='mandatory_field'>{errorMessage.landPicsError}</div> */}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} lg={4} hidden={growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency'}>
                                                                <Grid container spacing={1} >
                                                                    <Grid item xs={12} >
                                                                        <Tooltip title="Common point for bamboo pickup" arrow>
                                                                            <FormControl required>
                                                                                <FormLabel>{t('reg.aggregationPoint')}</FormLabel>
                                                                                <RadioGroup
                                                                                    row
                                                                                >
                                                                                    <FormControlLabel value="true" control={<Radio className='label_grower_reg' name="aggregationPoint" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.aggregationPoint === true} onChange={(e) => radioChange(e, true)} />} label={t('preReg.yes')} />
                                                                                    <FormControlLabel value="false" control={<Radio className='label_grower_reg' name="aggregationPoint" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.aggregationPoint === false} onChange={(e) => radioChange(e, false)} />} label={t('preReg.no')} />

                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                    {landUpdatedDetails?.aggregationPoint && <><Grid item xs={12}>
                                                                        <TextField fullWidth
                                                                            required
                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                            error={errorMessage?.aggregationNameError}
                                                                            helperText={errorMessage?.aggregationNameError}
                                                                            type="input"
                                                                            label={t('reg.aggregationPointName&Address')}
                                                                            name="aggregationPointName"
                                                                            value={landUpdatedDetails?.aggregationPointName}
                                                                            onChange={(e) => handleChange(e)}

                                                                        />
                                                                    </Grid>
                                                                        <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                                                            isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                            pincode={landUpdatedDetails?.aggregationPointPincode}
                                                                            state={landUpdatedDetails?.aggregationPointState}
                                                                            district={landUpdatedDetails?.aggregationPointDistrict}
                                                                            revenueCircle={landUpdatedDetails?.aggregationPointRevenueCircle}
                                                                            blockName={landUpdatedDetails?.aggregationPointBlockName}
                                                                            onHandleCallback={getAggregationUpdatedAddressData}
                                                                            pincodeError={errorMessage.aggregationPincodeError}
                                                                            blockNameError={errorMessage.aggregationrevenueCircleError}
                                                                            searchError={errorMessage.aggregationSearchError}
                                                                            handleChangeSelect={handleChangeSelectAggregation}
                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                        />
                                                                        <Grid item xs={12} mt={1}>
                                                                                <LocationPointMUI
                                                                                    latitudeLabel="Aggregation Point Latitude"
                                                                                    longitudeLabel="Aggregation Point Longitude"
                                                                                    latitudeName={t('preReg.latitude')}
                                                                                    longitudeName={t('preReg.longitude')}
                                                                                    latitude={landUpdatedDetails?.aggregationGeocodeLattitude}
                                                                                    longitude={landUpdatedDetails?.aggregationGeocodeLongitude}
                                                                                    callBackLocation={onAggregationLocationPoint}
                                                                                    latitudesError={errorMessage.aggregationLatitudesError}
                                                                                    longitudesError={errorMessage.aggregationLongitudesError}
                                                                                    isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                />
                                                                        </Grid></>}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} >
                                                                <Accordion mt={1} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (landDetailsSectionOk[selectedLandId] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}>
                                                                    <AccordionSummary
                                                                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                                    >
                                                                        <Typography variant="subtitle1" ml={2}>{t('reg.bamboo species details')}</Typography>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails>
                                                                        <Grid item xs={12}>
                                                                            <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                                                                                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                                                                    {/* <Typography variant="h6" gutterBottom>
                                                    Bamboo Species Details
                                                </Typography> */}
                                                                                </Stack>
                                                                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                                                                    {<Button disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onClick={(e) => addBamboo(e)} variant="contained" startIcon={<AddIcon />}>
                                                                                        {t('reg.addBambooDetails')}
                                                                                    </Button>}
                                                                                </Stack>
                                                                            </Stack>
                                                                            <DataGrid
                                                                                sx={{
                                                                                    "& .MuiDataGrid-columnHeaderTitle": {
                                                                                        whiteSpace: "normal",
                                                                                        lineHeight: "normal"
                                                                                    },
                                                                                    "& .MuiDataGrid-columnHeader": {
                                                                                        height: "unset !important"
                                                                                    },
                                                                                    "& .MuiDataGrid-columnHeaders": {
                                                                                        maxHeight: "168px !important"
                                                                                    }
                                                                                }}
                                                                                autoHeight
                                                                                rows={(landUpdatedDetails?.growerBambooSpecies)?.filter(o1 => (bambooSpeciesRes)?.some(o2 => o1.bambooSpecies === o2.id & (o1.isActive === 1 || o1.isActive === 3)))}
                                                                                pagination={false}
                                                                                hideFooterPagination
                                                                                columns={columns}
                                                                                disableColumnMenu={true}
                                                                                experimentalFeatures={{ newEditingApi: true }}
                                                                                getRowId={(row) => row.bambooSpecies}
                                                                            />
                                                                        </Grid>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            </Grid>
                                                        </Grid>
                                                        {showCommentSection && <>
                                                            <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                                                <Grid item xs={7}>
                                                                    <TextField sx={{ width: "100%" }}
                                                                        label={t('reg.comment')}
                                                                        name="comment"
                                                                        inputProps={{
                                                                            maxLength: 300,
                                                                        }}
                                                                        multiline
                                                                        disabled={(selectedLand && !shouldActOnSectionLand[selectedLandId]) || viewOnly}
                                                                        value={landComment}
                                                                        onChange={(e) => setLandComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                                                    />
                                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                                        <Badge bg={`${landComment?.length > characterLimit ? 'danger' : 'primary'}`}>{landComment?.length}/{characterLimit}</Badge>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <FormGroup>
                                                                        <FormControlLabel control={<Switch disabled={selectedLand && !shouldActOnSectionLand[selectedLandId]} checked={landDetailsSectionOk[selectedLandId]}
                                                                            onChange={(e) => setLandDetailsSectionOk({ ...landDetailsSectionOk, [selectedLandId]: e.target.checked })} />} label={<Typography variant="subtitle2" gutterBottom>
                                                                                {t('reg.detailsOk')}?
                                                                            </Typography>} />
                                                                    </FormGroup>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <Button variant="contained" disabled={selectedLand && !shouldActOnSectionLand[selectedLandId]}
                                                                        onClick={() => onSaveComment(landComment)}
                                                                        startIcon={<CommentIcon />}
                                                                    >
                                                                        {t('preReg.addComment')}
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                            <div>
                                                                <Accordion mt={1}>
                                                                    <AccordionSummary
                                                                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                                    >
                                                                        <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails>
                                                                        <Box style={{ height: 300, width: '100%' }}>
                                                                            <DataGrid
                                                                                rows={comments ? comments?.filter((item) => item.sectionName === "land_details" && item.sectionId === selectedLandId) : []}
                                                                                columns={commentsColumn}
                                                                                pageSize={10}
                                                                                getRowHeight={() => 'auto'}
                                                                            />
                                                                        </Box>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            </div>
                                                        </>}
                                                        {(!showWorkFlowButtons || (growerDetails?.growers[0]?.growerType === 'JFMC' && localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid)) && <Box display='flex' alignItems="center" justifyContent="center" mb={3} mt={2} style={{ float: "right" }}>
                                                             <Button sx={{ minWidth: 100 }} variant="outlined" startIcon={<CloseIcon />} onClick={() => {
                                                                setOpen((prevOpen) => ({
                                                                    ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false]))
                                                                })); row.id == "noId" && setNewLandObject([])
                                                            }}>Cancel</Button>
                                                             <Button startIcon={ addEditBtnName === t('reg.updateLand') ? <UpdateIcon /> : <AddIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true, growerDetails?.growers[0]?.growerType === 'JFMC' && true)} onClick={(e) => addLandBtnClick(e)}>{addEditBtnName}</Button>
                                                        </Box>}
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className='mandatory_field'>{errorMessage.landDetailsError}</div>
                        <div className='mandatory_field'>{errorMessage.landCommentError}</div>
                    </AccordionDetails>
                </Accordion>
            </Grid >
            <Dialog maxWidth='md' fullWidth open={logModalOpen}>
                <DialogContent>
                    <BambooSpeciesPopover bambooSpeciesSubmitCallbackFunction={bambooSpeciesSubmitCallbackFunction} growerBambooSpeciesList={bambooSpecies?.growerBambooSpeciesList} growerBambooSpecies={landUpdatedDetails?.growerBambooSpecies} landDetailsId={landUpdatedDetails?.landDetailsId}
                        editSpecies={editSpecies} otherSpeciesName={speciesName} handleLogModalClose={handleLogModalClose} bambooSpeciesRes={bambooSpeciesRes}
                        isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default LandDetails;
